<div class="aa-input-general gap-1 flex flex-col">
  <mat-label
    class="px-3 truncate"
    [title]="label | translate"
    [ngClass]="
      hasErrorState ? 'text-(--comp-input-label-error)' : 'text-(--comp-input-label-normal)'
    "
  >
    {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
  </mat-label>

  <mat-form-field appearance="outline" class="w-full example-full-width">
    <input
      type="text"
      aria-label="Number"
      matInput
      [formControl]="getInputGeneral"
      [matAutocomplete]="auto"
      [placeholder]="placeholder | translate"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      @for (option of (filteredOptions | async) ?? arrayData ?? []; track option) {
        <mat-option
          [value]="
            inputSelect && inputSelect.description !== ''
              ? getNestedProperty(option, inputSelect.description)
              : option
          "
        >
          {{
            inputSelect && inputSelect.description !== ''
              ? getNestedProperty(option, inputSelect.description)
              : option
          }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (formControlGeneral?.hasError('required')) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (formControlGeneral?.hasError('optionMismatch')) {
      <mat-error>{{ 'inputs.invalidFormat' | translate }}</mat-error>
    }
  </mat-form-field>
</div>
